export const API_URL_DOMAIN_KEY = 'https://api.webinarsystems.ru';
export const API_URL_IDENTITY_DOMAIN_KEY = 'https://identity.webinarsystems.ru/identity/GetPWDAccessToken';


export const API_URL_NODE_SERVER_DOMAIN_KEY = 'http://10.0.0.253:9001';